






























import { Component, Vue } from 'vue-property-decorator';
import { Getter, Action } from 'vuex-class';

import { appsApi } from '@/features/apps/shared/services/apps';
import WorkspaceViewModel from '@/workspaces/models/workspaceViewModel';
import { PrivateApp } from '@/features/apps/shared/models';
import { HANDLE_SERIOUS_ERROR } from '@/store/app/actionTypes';

@Component({
	beforeRouteEnter(to: any, from: any, next: any) {
		next((vm: PrivateAppsList) => {
			vm.$emit('loading');
		});
	}
})
export default class PrivateAppsList extends Vue {
	@Getter public currentWorkspace!: WorkspaceViewModel;
	@Action(HANDLE_SERIOUS_ERROR) public handleSeriousError: any;

	public apps: PrivateApp[] = [];

	public created() {
		if (!this.currentWorkspace) {
			this.handleSeriousError('No workspace selected');
			return;
		}

		appsApi.listPrivate(this.currentWorkspace.id)
			.then(apps => {
				this.apps = apps;
			}).catch(err => {
				this.handleSeriousError(err.message);
			}).finally(() => this.$emit('loaded'));
	}
}
